import React, { useMemo } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import IconMask from "../IconMask";
import { buildIntelligentReport } from "./reportBuilder";
import { useIntelligentReport } from "./IntelligentReportContext";

const IAReports = ({ values, selected, range = [], alarms = [], eventConfigurations = [] }) => {
  const user = useSelector((state) => state.session.globalUser);
  const theme = useTheme();
  const location = useLocation();
  const { openReport } = useIntelligentReport();
  const report = useMemo(
    () => buildIntelligentReport({ series: values, user, selected, range, alarms, eventConfigurations }),
    [values, user, selected, range, alarms, eventConfigurations]
  );

  const stopInteraction = (event) => {
    event.stopPropagation();
  };

  const handleOpen = (event) => {
    event.stopPropagation();
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    openReport(report, returnTo || "/");
  };

  const iconColor = theme.palette.mode === "dark" ? "white" : "gray";

  return (
    <Box sx={{ pointerEvents: "auto", position: "relative", zIndex: 6 }}>
      <Tooltip title="Abrir reporte inteligente">
        <IconButton
          size="large"
          variant="outlined"
          onMouseDown={stopInteraction}
          onClick={handleOpen}
          aria-label="Abrir reporte inteligente"
          sx={{ pointerEvents: "auto", position: "relative", zIndex: 1 }}
        >
          <IconMask color={iconColor} url="assets/icons/ia-tgone.svg" size={35} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default IAReports;
